import React from "react";
import CountUp from "react-countup";

const CounterBox = ({ data, cols }) => {
  return data.map((counter, i) => (
    <div
      key={i}
      className={cols === 3 ? "col-md-4 mt-4 pt-2" : "col-lg-3 mt-4 pt-2"}
    >
      <div className="counter-box text-center px-lg-4">
        <h4 className="mb-0 text-primary display-4">
          <span className="counter-value">
            <CountUp end={counter.end} duration={8} />
          </span>
          {counter.postFix}
        </h4>
        <h5 className="counter-head">{counter.title}</h5>
      </div>
    </div>
  ));
};

export default CounterBox;
